export enum AttendeeManagementRouteName {
  AttendeesList = 'attendees-list',
}
